module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/6-4929a837e5bc6c549ed063d068454839.webp";